export default class Validator {
  static String(message) {
    return new Validator(value => new Promise((resolve, reject) => {
      if (!value) {
        reject(message || { key: 'FORM__ERROR_REQUIRE' });
      } else {
        resolve();
      }
    }), true);
  }

  static StringMin(num, message) {
    return new Validator(value => new Promise((resolve, reject) => {
      if (value && value.length < num) {
        reject(message || {
          key: ['FORM__ERROR_MIN', ': ', 'num'],
          vars: { num },
        });
      } else {
        resolve();
      }
    }), false);
  }

  static StringMax(num, message) {
    return new Validator(value => new Promise((resolve, reject) => {
      if (value && value.length > num) {
        reject(message || {
          key: ['FORM__ERROR_MAX', ': ', 'num'],
          vars: { num },
        });
      } else {
        resolve();
      }
    }), false);
  }

  static StringFIO(message = { key: 'FORM__ERROR_FIO' }) {
    return new Validator(value => new Promise((resolve, reject) => {
      if (value && !value.match(/.(.)* .(.)* .(.)*/gi)) {
        reject(message);
      } else {
        resolve();
      }
    }), false);
  }

  static Object(message) {
    return new Validator(value => new Promise((resolve, reject) => {
      if (!value) {
        reject(message || { key: 'FORM__ERROR_REQUIRE' });
      } else {
        resolve();
      }
    }), true);
  }

  static Array(message) {
    return new Validator(value => new Promise((resolve, reject) => {
      if (!Array.isArray(value) || value?.length === 0) {
        reject(message || { key: 'FORM__ERROR_REQUIRE' });
      } else {
        resolve();
      }
    }), true);
  }

  static Boolean(message) {
    return new Validator(value => new Promise((resolve, reject) => {
      if (!value) {
        reject(message || { key: 'FORM__ERROR_REQUIRE' });
      } else {
        resolve();
      }
    }), true);
  }

  static Number(message) {
    return new Validator(value => new Promise((resolve, reject) => {
      if (!Number.isInteger(value) || value === 0) {
        reject(message || { key: 'FORM__ERROR_REQUIRE' });
      } else {
        resolve();
      }
    }), true);
  }

  static NumberMin(num, message) {
    return new Validator(value => new Promise((resolve, reject) => {
      if (value < num) {
        reject(message || {
          key: ['FORM__ERROR_MIN', ': ', 'num'],
          vars: { num },
        });
      } else {
        resolve();
      }
    }), false);
  }

  static NumberMax(num, message) {
    return new Validator(value => new Promise((resolve, reject) => {
      if (value > num) {
        reject(message || {
          key: ['FORM__ERROR_MAX', ': ', 'num'],
          vars: { num },
        });
      } else {
        resolve();
      }
    }), false);
  }

  static Email(num, message) {
    return new Validator(value => new Promise((resolve, reject) => {
      if (value && !value.match(/.(.)*@.(.)*\..(.)*/gi)) {
        reject(message || { key: 'FORM__ERROR_FORMAT' });
      } else {
        resolve();
      }
    }), false);
  }

  constructor(validator, require) {
    this.require = require;
    this.validator = validator;
  }
}
